/**
 * WheyDeals — refresh variant-dependent custom blocks.
 *
 * Problem this solves:
 *   When a shopper picks another flavour or size, Horizon only refreshes its
 *   own blocks (price, buy buttons, media). Our custom-liquid blocks kept the
 *   first variant's values, so a full-price 10Lb tub still showed
 *   "You save $40.00 (36% off)" from the discounted 2Lb, and the sticky
 *   add-to-cart bar kept the old price.
 *
 * Behaviour:
 *   After each variant change, every element marked
 *   data-wd-variant-refresh="<key>" takes the contents of its twin in the HTML
 *   Horizon has already fetched for the new variant (no extra request). If the
 *   new HTML has no twin, the element is emptied, so a saving that no longer
 *   applies is never left on screen.
 *
 * Deliberately standalone (rather than a patch to Horizon's own scripts) so a
 * theme update can't silently revert it.
 */
(() => {
  const ATTR = 'data-wd-variant-refresh';

  const selectorFor = (key) =>
    `[${ATTR}="${window.CSS && CSS.escape ? CSS.escape(key) : key}"]`;

  document.addEventListener('variant:update', (event) => {
    const picker = event.target;
    const html = event.detail && event.detail.data ? event.detail.data.html : null;
    if (!(picker instanceof Element) || !html || typeof html.querySelector !== 'function') return;

    // Swatches on product cards fire the same event; they never hold our blocks.
    if (picker.closest('product-card')) return;

    const scope = picker.closest('dialog, .shopify-section') || document;
    const targets = new Set(scope.querySelectorAll(`[${ATTR}]`));

    // The sticky add-to-cart bar is moved to <body>, outside the section.
    // Only the page's own product may update it, never a quick-add dialog.
    if (!picker.closest('dialog, featured-product-information')) {
      document.querySelectorAll(`body > #wd-satc [${ATTR}]`).forEach((el) => targets.add(el));
    }

    targets.forEach((el) => {
      const key = el.getAttribute(ATTR) || '';
      const fresh = html.querySelector(selectorFor(key));
      const next = fresh ? fresh.innerHTML : '';
      if (el.innerHTML !== next) el.innerHTML = next;
    });
  });
})();